module.exports = __webpack_public_path__ + "img/65A0BA_C3E4F1_A7D5E6_97CADF-256px.48e89ec3.png";